import { widgets, reducers, selectors, types, actions } from "./VRCore/widgets";

export const TotalClientInfoWidget = {
    view: widgets.TotalClientInfoWidget,
    reducer: reducers.TotalClientInfoWidget_reducer,
    reducer_key: "TotalClientInfoWidget_reducer",
    createSelectors: selectors.TotalClientInfoWidget_selector,
};
export const BuildVersionWidget = {
    view: widgets.BuildVersionWidget,
    reducer: reducers.BuildVersionWidget_reducer,
    reducer_key: "BuildVersionWidget_reducer",
    createSelectors: selectors.BuildVersionWidget_selector,
};
export const MessengerWidget = {
    view: widgets.MessengerWidget,
    reducer: reducers.MessengerWidget_reducer,
    reducer_key: "MessengerWidget_reducer",
    createSelectors: selectors.MessengerWidget_selector,
};
export const ActivityLogWidget = {
    view: widgets.ActivityLogWidget,
    reducer: reducers.ActivityLogWidget_reducer,
    reducer_key: "ActivityLogWidget_reducer",
    createSelectors: selectors.ActivityLogWidget_selector,
};
export const JobPackTrainingRulesWidget = {
    view: widgets.JobPackTrainingRulesWidget,
    reducer: reducers.JobPackTrainingRulesWidget_reducer,
    reducer_key: "JobPackTrainingRulesWidget_reducer",
    createSelectors: selectors.JobPackTrainingRulesWidget_selector,
};
export const JobPackToolboxTalkWidget = {
    view: widgets.JobPackToolboxTalkWidget,
    reducer: reducers.JobPackToolboxTalkWidget_reducer,
    reducer_key: "JobPackToolboxTalkWidget_reducer",
    createSelectors: selectors.JobPackToolboxTalkWidget_selector,
};
export const JobPackMapWidget = {
    view: widgets.JobPackMapWidget,
    reducer: reducers.JobPackMapWidget_reducer,
    reducer_key: "JobPackMapWidget_reducer",
    createSelectors: selectors.JobPackMapWidget_selectors,
};
export const ReportMapWidget = {
    view: widgets.ReportMapWidget,
    reducer: reducers.ReportMapWidget_reducer,
    reducer_key: "ReportMapWidget_reducer",
    createSelectors: selectors.ReportMapWidget_selectors,
};
export const JobPackTotalWidget = {
    view: widgets.JobPackTotalWidget,
    reducer: reducers.JobPackTotalWidget_reducer,
    reducer_key: "JobPackTotalWidget_reducer",
    createSelectors: selectors.JobPackTotalWidget_selector,
};
export const ReportTotalWidget = {
    view: widgets.ReportTotalWidget,
    reducer: reducers.ReportTotalWidget_reducer,
    reducer_key: "ReportTotalWidget_reducer",
    createSelectors: selectors.ReportTotalWidget_selector,
};
export const UserTotalWidget = {
    view: widgets.UserTotalWidget,
    reducer: reducers.UserTotalWidget_reducer,
    reducer_key: "UserTotalWidget_reducer",
    createSelectors: selectors.UserTotalWidget_selector,
};
export const ReportTotalBarChartWidget = {
    view: widgets.ReportTotalBarChartWidget,
    reducer: reducers.ReportTotalBarChartWidget_reducer,
    reducer_key: "ReportTotalBarChartWidget_reducer",
    createSelectors: selectors.ReportTotalBarChartWidget_selectors,
};
export const DateRangePickerWidget = {
    view: widgets.DateRangePickerWidget,
    reducer: reducers.DateRangePickerWidget_reducer,
    reducer_key: "DateRangePickerWidget_reducer",
    createSelectors: selectors.DateRangePickerWidget_selectors,
};
export const NewsBroadcastWidget = {
    view: widgets.NewsBroadcastWidget,
    reducer: reducers.NewsBroadcastWidget_reducer,
    reducer_key: "NewsBroadcastWidget_reducer",
    createSelectors: selectors.NewsBroadcastWidget_selectors,
};
export const NewsBroadcastV2Widget = {
    view: widgets.NewsBroadcastV2Widget,
    reducer: reducers.NewsBroadcastV2Widget_reducer,
    reducer_key: "NewsBroadcastV2Widget_reducer",
    createSelectors: selectors.NewsBroadcastV2Widget_selectors,
};
export const UserManagerV4TableDataWidget = {
    view: widgets.UserManagerV4TableDataWidget,
    reducer: reducers.UserManagerV4TableDataWidget_reducer,
    reducer_key: "UserManagerV4TableDataWidget_reducer",
    createSelectors: selectors.UserManagerV4TableDataWidget_selector,
};

export const AddUserV4Widget = {
    view: widgets.UserManagerV4AddUserWidget,
    reducer: reducers.UserManagerV4AddUserWidget_reducer,
    reducer_key: "UserManagerV4AddUserWidget_reducer",
    createSelectors: selectors.UserManagerV4AddUserWidget_selector,
};
export const ReportTotalDetailWidget = {
    view: widgets.ReportTotalDetailWidget,
    reducer: reducers.ReportTotalDetailWidget_reducer,
    reducer_key: "ReportTotalDetailWidget_reducer",
    createSelectors: selectors.ReportTotalDetailWidget_selectors,
};
export const UserReportTotalWidget = {
    view: widgets.UserReportTotalWidget,
    reducer: reducers.UserReportTotalWidget_reducer,
    reducer_key: "UserReportTotalWidget_reducer",
    createSelectors: selectors.UserReportTotalWidget_selectors,
};
export const BuildExcelDocWidget = {
    view: widgets.BuildExcelDocWidget,
    reducer: reducers.BuildExcelDocWidget_reducer,
    reducer_key: "BuildExcelDocWidget_reducer",
    createSelectors: selectors.BuildExcelDocWidget_selectors,
};
export const UserManagerTableDataWidget = {
    view: widgets.UserManagerTableDataWidget,
    reducer: reducers.UserManagerTableDataWidget_reducer,
    reducer_key: "UserManagerTableDataWidget_reducer",
    createSelectors: selectors.UserManagerTableDataWidget_selector,
};
export const JobPackProfileInfoWidget = {
    view: widgets.JobPackProfileInfoWidget,
};
export const JobPackProfileAddressWidget = {
    view: widgets.JobPackProfileAddressWidget,
};
export const JobPackProfileAssigneeWidget = {
    view: widgets.JobPackProfileAssigneesWidget,
};
export const JobPackProfileUploadFilesWidget = {
    view: widgets.JobPackProfileUploadFilesWidget,
};
export const JobPackProfileAttachedPhotosWidget = {
    view: widgets.JobPackProfileAttachedPhotosWidget,
};

export const JobPackProfileRelatedReportsWidget = {
    view: widgets.JobPackProfileRelatedReportsWidget,
    reducer: reducers.JobPackProfileRelatedReportsWidget_reducer,
    reducer_key: "JobPackProfileRelatedReportsWidget_reducer",
    createSelectors: selectors.JobPackProfileRelatedReportsWidget_selector,
};
export const AddUserWidget = {
    view: widgets.UserManagerAddUserWidget,
    reducer: reducers.UserManagerAddUserWidget_reducer,
    reducer_key: "UserManagerAddUserWidget_reducer",
    createSelectors: selectors.UserManagerAddUserWidget_selector,
};
export const JobPackAssignessArrayList = {
    view: widgets.JobPackProfileJobPackAssigneesArrayList,
};
export const JobPackSelectReportsWidget = {
    view: widgets.JobPackSelectReportsWidget,
};
export const ReportAlertsWidget = {
    view: widgets.AlertsWidgetReportAlerts,
    reducer: reducers.AlertsWidgetReportAlerts_reducer,
    reducer_key: "AlertsWidgetReportAlerts_reducer",
    createSelectors: selectors.AlertsWidgetReportAlerts_selector,
};

export const QualificationAlertsWidget = {
    view: widgets.AlertsWidgetQualificationAlerts,
    reducer: reducers.AlertsWidgetQualificationAlerts_reducer,
    reducer_key: "AlertsWidgetQualificationAlerts_reducer",
    createSelectors: selectors.AlertsWidgetQualificationAlerts_selector,
};

// export const VehicleAlertsWidget = {
//     view: widgets.AlertsWidgetReportAlerts,
//     reducer: reducers.AlertsWidgetReportAlerts_reducer,
//     reducer_key: "AlertsWidgetReportAlerts_reducer",
//     createSelectors: selectors.AlertsWidgetReportAlerts_selector
// };

export const JobPackVehicleListWidget = {
    view: widgets.JobPackVehicleListWidget,
    reducer: reducers.JobPackVehicleListWidget_reducer,
    reducer_key: "JobPackVehicleListWidget_reducer",
    createSelectors: selectors.JobPackVehicleListWidget_selectors,
};
export const JobPackEquipmentListWidget = {
    view: widgets.JobPackEquipmentListWidget,
    reducer: reducers.JobPackEquipmentListWidget_reducer,
    reducer_key: "JobPackEquipmentListWidget_reducer",
    createSelectors: selectors.JobPackEquipmentListWidget_selectors,
};
export const JobPackAssignessArrayListWidget = {
    view: widgets.JobPackAssigneesArrayListWidget,
    reducer: reducers.JobPackAssigneesArrayListWidget_reducer,
    reducer_key: "JobPackAssigneesArrayListWidget_reducer",
    createSelectors: selectors.JobPackAssigneesArrayListWidget_selectors,
};
export const JobPackGeneralFilesWidget = {
    view: widgets.JobPackGeneralFilesWidget,
    createReducer: reducers.JobPackGeneralFilesWidget_reducer,
    createTypes: types.JobPackGeneralFilesWidget_types,
    createSelectors: selectors.JobPackGeneralFilesWidget_selectors,
    createActions: actions.JobPackGeneralFilesWidget_actions,
};
export const JobPackMethodStatementWidget = {
    view: widgets.JobPackMethodStatementsWidget,
    reducer: reducers.JobPackMethodStatementsWidget_reducer,
    reducer_key: "JobPackMethodStatementsWidget_reducer",
    createSelectors: selectors.JobPackMethodStatementsWidget_selector,
};
export const JobPackSelectReports = {
    view: widgets.JobPackSelectReports,
    reducer: reducers.JobPackSelectReportsWidget_reducer,
    reducer_key: "JobPackSelectReportsWidget_reducer",
    createSelectors: selectors.JobPackSelectReportsWidget_selectors,
};
export const ProWorkFooter = {
    view: widgets.ProWorkFooter,
};
